import FloatingWindowLayout from './FloatingWindowLayout';
import './FloatingWindowLayout.css';

export default FloatingWindowLayout;


// WEBPACK FOOTER //
// ./src/shared/components/FloatingWindowLayout/index.js